module.exports = {"TXTCLI_Remove":{"id":"TXTCLI_Remove","defaultMessage":"Supprimer","track":"Remove"}}